import { Component } from '@angular/core';
import { UilabMatButton, UilabMatTooltip } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface TooltipExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-tooltip-examples',
    templateUrl: './tooltip-examples.component.html',
    styleUrls: ['./tooltip-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatButton,
        UilabMatTooltip,
    ],
})
export class TooltipExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-tooltip--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/tooltip`;

    readonly examples: readonly TooltipExample[] = [
        {
            variant: 'basic',
            label: 'Basic Tooltip',
            description:
                'Use a tooltip to provide additional context on hover without taking up permanent space.',
            htmlSnippet: `<button uilabMatButton="filled" uilabMatTooltip="View details" uilabMatTooltipPosition="above">
  Hover for tooltip
</button>`,
        },
    ];
}
